import React from "react";
import ReactDOM from "react-dom";
import queryString from "qs";

const ratingElement = document.getElementById("rating");
const ratingPopupElement = document.getElementById("ratingPopup");
const popupRatingElement = document.getElementById("popupRating");

const Rating = () => {
  const { ratingValue, reviewCount, id, type, title } = ratingElement.dataset;
  const [ratingCount, updateRatingCount] = React.useState(reviewCount);
  const [rating, updateRating] = React.useState(ratingValue);
  const [userRatingValue, updateUserRatingValue] = React.useState(0);
  const [temporaryRating, updateTemporaryRating] = React.useState(0);
  const [userHasRated, setUserHasRated] = React.useState(false);
  const [tooltip, updateTooltip] = React.useState({
    active: false,
    message: ""
  });

  const [popupActive, setPopupActive] = React.useState(false);

  React.useEffect(() => {
    if (popupActive) {
      ratingPopupElement.classList.add("active");
    } else {
      ratingPopupElement.classList.remove("active");
    }
  }, [popupActive]);

  const handleSetRatingAfterFormSubmission = () => {
    // const body = queryString.stringify({
    //   nonce: wp.nonce,
    //   action: "do_rating",
    //   post_id: id,
    //   type: type,
    //   rating: rating
    // });

    // fetch(wp.ajaxUrl, {
    //   method: "POST",
    //   credentials: "same-origin",
    //   headers: new Headers({
    //     "Content-Type": "application/x-www-form-urlencoded"
    //   }),
    //   body: body
    // })
    //   .then(res => res.json())
    //   .then(res => {
    //     updateRating(res.rating);
    //     updateRatingCount(res.amount_ratings);
    //   });

    const body = queryString.stringify({
      nonce: wp.nonce,
      action: "do_rating",
      post_id: id,
      type: type,
      rating: userRatingValue
    });

    fetch(wp.ajaxUrl, {
      method: "POST",
      credentials: "same-origin",
      headers: new Headers({
        "Content-Type": "application/x-www-form-urlencoded"
      }),
      body: body
    })
      .then(res => res.json())
      .then(res => {
        updateRating(res.rating);
        updateRatingCount(res.amount_ratings);
      });
  };

  React.useEffect(() => {
    // i couldnt get it to work without jQuery, i'm sorry
    jQuery(document).on(
      "gform_confirmation_loaded",
      handleSetRatingAfterFormSubmission
    );

    return () =>
      jQuery(document).off(
        "gform_confirmation_loaded",
        handleSetRatingAfterFormSubmission
      );
  }, [userRatingValue]);

  React.useMemo(() => {
    document
      .querySelector(".ratingPopup .closePopup")
      .addEventListener("click", () => {
        setPopupActive(false);
      });

    document
      .querySelector(".ratingPopup .popupOverlay")
      .addEventListener("click", () => {
        setPopupActive(false);
      });
  });

  React.useEffect(() => {
    popupRatingElement.innerText = userRatingValue;
  }, [userRatingValue]);

  const handleSetRating = rating => {
    if (!userHasRated) {
      updateUserRatingValue(rating);
      updateTemporaryRating(0);
      if (rating < 5) {
        setPopupActive(true);
        setUserHasRated(true);
      } else {
        setUserHasRated(true);
        updateTooltip({ active: true, message: "Bedankt voor je beoordeling" });

        const body = queryString.stringify({
          nonce: wp.nonce,
          action: "do_rating",
          post_id: id,
          type: type,
          rating: rating
        });

        fetch(wp.ajaxUrl, {
          method: "POST",
          credentials: "same-origin",
          headers: new Headers({
            "Content-Type": "application/x-www-form-urlencoded"
          }),
          body: body
        })
          .then(res => res.json())
          .then(res => {
            updateRating(res.rating);
            updateRatingCount(res.amount_ratings);
          });
      }
    } else {
      updateTooltip({ active: true, message: "Je hebt al beoordeeld" });
    }
    setTimeout(() => {
      updateTooltip({ ...tooltip, active: false });
    }, 3000);
  };

  const _rating = userHasRated
    ? userRatingValue
    : temporaryRating !== 0
    ? temporaryRating
    : ratingValue;

  if (window.innerWidth < 991) {
    return null;
  }

  return (
    <>
      <div className={`rating normal ${userHasRated && "userHasRated"}`}>
        <div className="title">Beoordeel deze {title}</div>

        <div className="ratingStars">
          <div className={`ratingTooltip ${tooltip.active && "active"}`}>
            <span>{tooltip.message}</span>
          </div>
          <StartRating
            rating={_rating}
            updateTemporaryRating={updateTemporaryRating}
            setRating={handleSetRating}
          />
        </div>

        <div className="ratingInfo">
          <div>
            <span className="ratingValue">{rating}</span> / <span>10</span> (
            <span className="ratingCount">{ratingCount}</span> stemmen)
          </div>
        </div>
      </div>
    </>
  );
};

const StartRating = ({ rating, updateTemporaryRating, setRating }) => {
  const stars = [];

  for (let i = 1; i < 11; i++) {
    if (i % 2 == 0) {
      stars.push({
        left: Math.round(rating) < i - 1 ? false : true,
        right: Math.round(rating) < i ? false : true
      });
    }
  }

  const handleOnMouseEnter = (event, rating) => {
    updateTemporaryRating(rating);
  };

  const handleOnClick = (event, rating) => {
    setRating(rating);
  };

  return (
    <div className="stars" onMouseLeave={() => updateTemporaryRating(0)}>
      {stars.map((r, i) => (
        <Star
          data={r}
          index={i}
          key={i}
          onMouseEnter={handleOnMouseEnter}
          onClick={handleOnClick}
        />
      ))}
    </div>
  );
};

const Star = ({ data, index, onMouseEnter, onClick }) => {
  return (
    <>
      <div className="star">
        <HalfAStar
          position="left"
          active={data.left}
          onMouseEnter={event => onMouseEnter(event, (index + 1) * 2 - 1)}
          onClick={event => onClick(event, (index + 1) * 2 - 1)}
        />
        <HalfAStar
          position="right"
          active={data.right}
          onMouseEnter={event => onMouseEnter(event, (index + 1) * 2)}
          onClick={event => onClick(event, (index + 1) * 2)}
        />
      </div>
    </>
  );
};

const HalfAStar = ({ active, position, onMouseEnter, onClick }) => {
  return (
    <span
      className={`startHalf starHalf--${position} ${active && "active"}`}
      onMouseEnter={onMouseEnter}
      onClick={onClick}
    >
      <svg
        focusable="false"
        className="svg-inline--fa fa-star fa-w-18"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 576 512"
      >
        <path
          fill="currentColor"
          d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"
        ></path>
      </svg>
    </span>
  );
};

if (ratingElement) {
  ReactDOM.render(<Rating />, ratingElement);
}
